import React from 'react';
import NoEvents from '../../../../../assets/icons/events/noevents.svg';

import { DefaultContainer } from './styled';

const EmptyStateProcedureMessage = () => (
  <DefaultContainer>
    <div className="imgWidth">
      <img width={65} src={NoEvents} alt="" />
    </div>
    Aún no has realizado algún trámite
  </DefaultContainer>
);

export default EmptyStateProcedureMessage;
